import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Card, CardContent } from '../components/ui/Card';
export function ViewCourse() {
  const navigate = useNavigate();
  return <div className="space-y-4" data-id="element-2438">
      <div className="flex items-center justify-between" data-id="element-2439">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-2440">Course</h1>
        <Button variant="secondary" size="sm" className="border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" onClick={() => navigate('/courses')} data-id="element-2441">
          ← Back to Courses
        </Button>
      </div>

      <Card data-id="element-2442">
        <CardContent className="pt-6" data-id="element-2443">
          <table className="text-sm w-full" data-id="element-2444">
            <tbody data-id="element-2445">
              <tr className="border-b border-slate-100" data-id="element-2446">
                <td className="py-2 pr-6 font-medium text-slate-700 w-36 align-top" data-id="element-2447">
                  Name
                </td>
                <td className="py-2 text-slate-900" data-id="element-2448">
                  Ethics &amp; The Rules (with NAR Code of Ethics)
                </td>
              </tr>
              <tr className="border-b border-slate-100" data-id="element-2449">
                <td className="py-2 pr-6 font-medium text-slate-700 align-top" data-id="element-2450">
                  Course Category
                </td>
                <td className="py-2 text-slate-900" data-id="element-2451">Single class</td>
              </tr>
              <tr className="border-b border-slate-100" data-id="element-2452">
                <td className="py-2 pr-6 font-medium text-slate-700 align-top" data-id="element-2453">
                  Small Description
                </td>
                <td className="py-4 text-slate-800 leading-relaxed max-w-2xl" data-id="element-2454">
                  <div className="space-y-3" data-id="element-2455">
                    <p className="font-bold text-blue-700" data-id="element-2456">
                      CS CE credit + Complies with current NAR cycle January
                      2025-December 2027
                    </p>
                    <p data-id="element-2457">
                      The Commissioner's Rule R4-28-1101 will be the primary
                      focus of the class as it compares to the NAR Code Of
                      Ethics for REALTORS®. There will be a review of the
                      process of enforcement of both the Rules and Code of
                      Ethics. Recent changes will be addressed as well as those
                      that are often overlooked.
                    </p>
                    <p className="bg-yellow-200 font-bold px-1" data-id="element-2458">
                      REMEMBER:SEND A COPY OF YOUR CERTIFICATE TO YOUR LOCAL
                      ASSOCIATION.
                    </p>
                    <p className="bg-yellow-200 font-bold px-1" data-id="element-2459">
                      Find Email Address:{' '}
                      <a href="#" className="text-blue-600 underline" data-id="element-2460">
                        https://www.DesertSageSeminars.com/Arizona_Local_Associations
                      </a>
                    </p>
                  </div>
                </td>
              </tr>
              <tr className="border-b border-slate-100" data-id="element-2461">
                <td className="py-2 pr-6 font-medium text-slate-700 align-top" data-id="element-2462">
                  Full Description
                </td>
                <td className="py-4 text-slate-800 leading-relaxed max-w-2xl" data-id="element-2463">
                  <div className="space-y-3" data-id="element-2464">
                    <p className="font-bold text-blue-700" data-id="element-2465">
                      CS CE credit + Complies with current NAR cycle January
                      2025-December 2027
                    </p>
                    <p data-id="element-2466">
                      The Commissioner's Rule R4-28-1101 will be the primary
                      focus of the class as it compares to the NAR Code Of
                      Ethics for REALTORS®. There will be a review of the
                      process of enforcement of both the Rules and Code of
                      Ethics. Recent changes will be addressed as well as those
                      that are often overlooked.
                    </p>
                    <p className="bg-yellow-200 font-bold px-1" data-id="element-2467">
                      REMEMBER:SEND A COPY OF YOUR CERTIFICATE TO YOUR LOCAL
                      ASSOCIATION.
                    </p>
                    <p className="bg-yellow-200 font-bold px-1" data-id="element-2468">
                      Find Email Address:{' '}
                      <a href="#" className="text-blue-600 underline" data-id="element-2469">
                        https://www.DesertSageSeminars.com/Arizona_Local_Associations
                      </a>
                    </p>
                    <p data-id="element-2470">
                      ****This Class Will Comply With NAR Code of Ethics
                      requirement PLUS 3 CE hrs. for Commissioner's Standards***
                    </p>
                    <p data-id="element-2471">
                      <em data-id="element-2472">
                        Jon Kichen, the owner of Desert SageSeminars and
                        instructor of this course, is approved by the Arizona
                        Association of Realtors as a Certified Ethics
                        Instructor.
                      </em>
                    </p>
                    <p data-id="element-2473">
                      *When completed, be sure to send a copy this certificate
                      to your local Association to show you have complied with
                      NAR's Code of Ethics requirement. Go to{' '}
                      <a href="#" className="text-blue-600 underline" data-id="element-2474">
                        LINKS/RESOURCES
                      </a>{' '}
                      for email address of your local Association.
                    </p>
                    <p data-id="element-2475">
                      When you click to print your certificate, the system will
                      download a PDF (of your certificate). You can save it and
                      then attach it to an email to your Association.
                    </p>
                    <div className="pl-4 space-y-1" data-id="element-2476">
                      <p data-id="element-2477">
                        *Per ADRE rules, you may NOT complete more than 3
                        classes (9 hrs.) in a calendar day
                      </p>
                    </div>
                    <p className="text-blue-700 font-medium" data-id="element-2478">
                      The Arizona Department of Real Estate requires that we
                      confirm your identity and that you are the person taking
                      the classes. Impersonating a real estate licensee is a
                      felony in the State of Arizona and will be subject to a
                      real estate forfeiture for either or both parties. If you
                      are NOT the person named in the registration, we strongly
                      recommend that you log out and not continue. We reserve
                      the right to use reasonable means to verify your identity.
                    </p>
                    <p data-id="element-2479">There are 5 sections to this course</p>
                    <p data-id="element-2480">
                      Take NOTES: You can print pages or copy &amp; paste for
                      your notes
                    </p>
                    <p data-id="element-2481">
                      You can review the material at any time throughout the
                      course
                    </p>
                    <p data-id="element-2482">You need 100% to pass each quiz in order to proceed</p>
                    <p data-id="element-2483">
                      You need 80% to pass the final. The final is a compilation
                      of the quiz questions you already answered
                    </p>
                    <p data-id="element-2484">
                      Your certificate will be date stamped upon completion of
                      your final.
                    </p>
                    <p data-id="element-2485">
                      If you would like to remain paperless, when you click
                      "Print Certificate", a PDF will also be downloaded on your
                      computer. Save in a folder for <strong data-id="element-2486">5</strong> years
                      (per ADRE rules)
                    </p>
                  </div>
                </td>
              </tr>
              <tr className="border-b border-slate-100" data-id="element-2487">
                <td className="py-2 pr-6 font-medium text-slate-700" data-id="element-2488">
                  Passing Score
                </td>
                <td className="py-2 text-slate-900" data-id="element-2489">80</td>
              </tr>
              <tr className="border-b border-slate-100" data-id="element-2490">
                <td className="py-2 pr-6 font-medium text-slate-700" data-id="element-2491">
                  Credit Type
                </td>
                <td className="py-2" data-id="element-2492">
                  <a href="#" className="text-blue-600 hover:underline" data-id="element-2493">
                    3 hrs. Comm. Standards
                  </a>
                </td>
              </tr>
              <tr className="border-b border-slate-100" data-id="element-2494">
                <td className="py-2 pr-6 font-medium text-slate-700" data-id="element-2495">
                  Course No
                </td>
                <td className="py-2 text-slate-900" data-id="element-2496">CD17355</td>
              </tr>
              <tr className="border-b border-slate-100" data-id="element-2497">
                <td className="py-2 pr-6 font-medium text-slate-700" data-id="element-2498">
                  Publish
                </td>
                <td className="py-2 text-slate-900" data-id="element-2499">yes</td>
              </tr>
              <tr data-id="element-2500">
                <td className="py-2 pr-6 font-medium text-slate-700" data-id="element-2501">Price</td>
                <td className="py-2 text-slate-900" data-id="element-2502">$19.95</td>
              </tr>
            </tbody>
          </table>
        </CardContent>
      </Card>
    </div>;
}